/* import __COLOCATED_TEMPLATE__ from './spinner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface BvTextFieldSpinnerSignature {
  Args: {
    onChange?: (steps: number) => void;
    onClick?: () => void;
    onDecrease?: () => void;
    onIncrease?: () => void;
  };
}

const BvTextFieldSpinnerComponent = templateOnlyComponent<BvTextFieldSpinnerSignature>();

export default BvTextFieldSpinnerComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvTextField::Spinner': typeof BvTextFieldSpinnerComponent;
    'bv-text-field/spinner': typeof BvTextFieldSpinnerComponent;
  }
}
